import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringToArray'
})
export class StringToArrayPipe implements PipeTransform {
  transform(value: string, separator: string = ','): string[] {
    if (!value) {
      return [];
    }
    return value.split(separator).map(item => item.trim());
  }
}
